import { createContext, useContext } from 'react';

// Provided by TmuaPearsonShell (which owns the header/footer that need to
// hide when the keyboard opens) so any descendant editor can read the
// current keyboard inset without threading a prop through intermediate
// layers. Editors that do NOT render inside the shell (see
// docs/plans/MOBILE_EXAM_RUNNER_PLAN.md Phase 5) call useVisualViewportKeyboardInset()
// directly instead, since they have no shell ancestor to source this from.
export const TmuaPearsonKeyboardInsetContext = createContext(0);

export function useTmuaPearsonKeyboardInset() {
  return useContext(TmuaPearsonKeyboardInsetContext);
}
